import React, { useEffect } from 'react';
import c from '../helpers/constants';
import history from '../helpers/history';
import '../styles/Products.scss';
import View from '../components/View';
import PageHeader from '../components/PageHeader';
import SearchBarFilter from '../components/SearchBarFilter';
import Card from '../components/Card';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryImage } from '../helpers/functions';
import { didFetchingProductTypesFailed, getProductTypes, isFetchingProductTypes } from '../selectors/ProductType';
import { fetchProductTypes } from '../actions/ProductType';
import imgProducts from '../assets/images/Products.png';

import { ProductType } from '../types/ProductType';

const Products = () => {
  const fetchingProductTypes = useSelector(isFetchingProductTypes);
  const productTypes = useSelector(getProductTypes);
  const fetchingFailed = useSelector(didFetchingProductTypesFailed);

  const onClick = (productType: ProductType) => {
    history.push({ pathname: `${c.APP_ROUTES.SEARCH}`, search: `?productTypeCode=${productType.product_type_code}` });
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchProductTypes());
  }, [dispatch]);

  const onSearch = (term: string) => {
    history.push({ pathname: c.APP_ROUTES.SEARCH, search: `searchSelection=${term}` });
  };


  return (
        <View>
            <PageHeader text="Categories" imageUrl={imgProducts}/>
            <div className="container products">
                <div className="products__header">
                    <h3 className="products__header__title pb-5">
                        Choose from our wide range of products
                    </h3>
                    <div className="products__header__search">
                        <SearchBarFilter onSearch={onSearch}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mb-5 text-center">
                        {fetchingProductTypes && !fetchingFailed &&
                        <div className="spinner-border text-center text-dark" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        }
                    </div>
                </div>
                <div className="row gy-4 products__row">
                    {productTypes?.map((p) => (
                        <div key={p.product_type_code} className="col-lg-4 col-md-6 col-sm-6">
                            <Card
                                title={_.startCase(_.toLower(p?.product_type_desc))}
                                imageUrl={getCategoryImage(p.product_type_code)}
                                imageAlt={p.product_type_desc}
                                onClick={() => onClick(p)}
                            />
                        </div>
                    ))}
                </div>
            </div>

        </View>
  );
};

export default Products;
